<template>
    <i class="ico-svg-share">
        <svg v-bind="{ width, height }" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.833 11.667c-1.333 0-2.5.583-3.25 1.583l-4.416-2.167c.083-.416.166-.75.166-1.083 0-.333-.083-.75-.166-1.083l4.416-2.167c.75.917 1.917 1.583 3.25 1.583A4.126 4.126 0 0020 4.167 4.126 4.126 0 0015.833 0a4.126 4.126 0 00-4.166 4.167c0 .333.083.75.166 1.083L7.417 7.417C6.667 6.5 5.5 5.833 4.167 5.833A4.126 4.126 0 000 10a4.126 4.126 0 004.167 4.167c1.333 0 2.5-.667 3.25-1.667l4.416 2.167c-.083.416-.166.75-.166 1.166A4.126 4.126 0 0015.833 20 4.126 4.126 0 0020 15.833a4.126 4.126 0 00-4.167-4.166z" :fill="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconShare',

    props: {
        width: {
            type: Number,
            default: 20,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
